import { store } from 'redux/store';
import { Message } from 'components/Chatter/types';
import { SELECTED_CHAT_STORAGE_KEY } from 'components/Chatter/consts';
import { storeDealReduxStateForNewTab } from 'Utils/dealStateTransfer';

const MAX_PREVIEW_LENGTH = 120;

const decodeHtmlEntities = (() => {
  // removes HTML entity symbols from text
  const textarea = document.createElement('textarea');
  return (input: string) => {
    textarea.innerHTML = input;
    return textarea.value;
  };
})();

export const normaliseText = (value?: string) => {
  if (!value) return '';
  const text = decodeHtmlEntities(value);
  // collapse whitespace and trim text
  return text.replace(/\s+/g, ' ').trim();
};

export const buildMessagePreview = (message?: Message | null) => {
  const text = normaliseText(message?.contentText) || 'New message received';
  if (text.length <= MAX_PREVIEW_LENGTH) return text;
  return `${text.slice(0, MAX_PREVIEW_LENGTH - 1)}…`;
};

export const buildDealLink = ({
  dealName,
  dealId,
  dealDefId,
  dealStepDefId
}: {
  dealName: string;
  dealId: number;
  dealDefId: number;
  dealStepDefId: number;
}) => {
  const currentState = store.getState();

  const essentialState = {
    user: currentState.user,
    config: currentState.config,
    schema: currentState.schema,
    fb: currentState.fb,
    processes: currentState.process
  };

  const { stateId } = storeDealReduxStateForNewTab(essentialState);

  localStorage.setItem(
    'currentDealData',
    JSON.stringify({
      ProcessInstanceId: dealId,
      ProcessDefinitionId: dealDefId,
      ProcessStepDefinitionId: dealStepDefId,
      ProcessInstanceTitle: dealName
    })
  );

  const encodedDealName = encodeURIComponent(dealName || 'Deal');
  const dealUrl = `${window.location.origin}/deal/${dealId}?name=${encodedDealName}&defId=${dealDefId}&stepId=${dealStepDefId}&stateId=${encodeURIComponent(stateId)}`;
  return encodeURI(dealUrl);
};

export const buildDashboardLink = () => {
  const currentState = store.getState();

  const essentialState = {
    user: currentState.user,
    config: currentState.config,
    schema: currentState.schema,
    fb: currentState.fb,
    processes: currentState.process
  };

  const { stateId } = storeDealReduxStateForNewTab(essentialState);
  const dashboardUrl = `${window.location.origin}/dashboard?stateId=${encodeURIComponent(stateId)}`;

  return encodeURI(dashboardUrl);
};

export const getSelectedChatFromStorage = () => {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.sessionStorage.getItem(SELECTED_CHAT_STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as { chatId: string; dealId: number };
  } catch (error) {
    console.warn('Failed to read active chat state', error);
    return null;
  }
};
